import React, { useState } from 'react'

export default function Activities({ activities }) {
  const [openActivities, setOpenActivities] = useState(false)
  const bottomBorder = { borderBottom: '1px solid #f1f1f1' }

  return(
    <>
      <div className='card'>
        <div className='card-content'>
          <div className='card-title flex-box content-space-between'>
            <div>Onboarding Activity</div>
            <i onClick={ ()=> setOpenActivities(prevState => !prevState) } className={`pointer fa-light ${openActivities ? 'fa-chevron-up' : 'fa-chevron-down' }`} />
          </div>
          { openActivities &&
            <div className='card-body'>
              <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                <div style={{ fontSize: 13 }}>Received Customer Information</div>
                <div className='bold' style={{ fontSize: 13 }}>{ activities.info_received || 'Pending' }</div>
              </div>
              <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                <div style={{ fontSize: 13 }}>Contract created (assuming sent by then)</div>
                <div className='bold' style={{ fontSize: 13 }}>{ activities.sent_contract || 'Pending' }</div>
              </div>
              <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                <div style={{ fontSize: 13 }}>Received signed contract from Customer</div>
                <div className='bold' style={{ fontSize: 13 }}>{ activities.received_contract || 'Pending' }</div>
              </div>
              { activities.informed_provider_authorization &&
                <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                  <div style={{ fontSize: 13 }}>Informed provider for authorization</div>
                  <div className='bold' style={{ fontSize: 13 }}>{ activities.informed_provider_authorization || '-' }</div>
                </div>
              }
              <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                <div style={{ fontSize: 13 }}>Accepted authorization</div>
                <div className='bold' style={{ fontSize: 13 }}>{ activities.accepted_authorization || 'Pending' }</div>
              </div>
              <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                <div style={{ fontSize: 13 }}>Completed statement from customer</div>
                <div className='bold' style={{ fontSize: 13 }}>{ activities.completed_statement || 'Pending' }</div>
              </div>
              { activities.informed_provider_statement &&
                <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                  <div style={{ fontSize: 13 }}>Informed provider for client's documents</div>
                  <div className='bold' style={{ fontSize: 13 }}>{ activities.informed_provider_statement || '-' }</div>
                </div>
              }
              <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                <div style={{ fontSize: 13 }}>Added API Keys</div>
                <div className='bold' style={{ fontSize: 13 }}>{ activities.added_api_key || 'Pending' }</div>
              </div>
              <div className='flex-box items-center content-space-between p-t-10 p-b-10' style={ bottomBorder }>
                <div style={{ fontSize: 13 }}>Notified customer for API Keys</div>
                <div className='bold' style={{ fontSize: 13 }}>{ activities.notified_api_keys || 'Not yet informed' }</div>
              </div>
            </div>
          }
        </div>
      </div>

    </>
  )
}